<template>
  <div class="task task-detail" v-if="detailObj">
    <div class="task-detail-left">
      <div>
        <p class="title">
          <span
            class="tit"
            @click="
              $router.push({
                name: 'task',
                query: { ...$route.query }
              })
            "
            >任务库</span
          ><span> - {{ detailObj.name }}</span>
        </p>
        <div class="task-detail-left-bottom">
          <p class="taps"><span class="tap-left"></span>任务名称</p>
          <p class="name">{{ detailObj.name }}</p>
          <p class="taps"><span class="tap-left"></span>任务介绍</p>
          <div class="des">{{ detailObj.description }}</div>
          <p class="taps"><span class="tap-left"></span>环境要求</p>
          <p class="name mb79">
            {{ detailObj.envNote ? detailObj.envNote : '无' }}
          </p>
          <p class="taps"><span class="tap-left"></span>工具要求</p>
          <div>
            <p class="mt14" v-if="!detailObj.toolNote">无</p>
            <div v-else class="tool">
              <div v-for="(item, index) in detailObj.tools" :key="index">
                <img :src="item.icon" @click="openTool(item.note)" />
              </div>
            </div>
          </div>
          <p class="taps mt60"><span class="tap-left"></span>任务难度</p>
          <div class="difficulty">
            <div v-for="(item, index) in star" :key="index">
              <img v-if="item <= detailObj.difficulty" src="/images/star-m.png" />
              <img v-else src="/images/star.png" />
            </div>
          </div>
        </div>
      </div>

      <div class="downBtn">
        <Button type="primary" @click="downFile()">下载文档</Button>
      </div>
    </div>
    <div class="task-detail-right">
      <p class="title">任务步骤</p>
      <div v-if="detailObj.stepNote && detailObj.stepNote[0]" class="step-all">
        <!-- <div class="step" v-for="(item, index) in detailObj.stepNote" :key="index">
          <div class="step-left">
            <div class="line  animate__animated animate__fadeInUp"></div>
            <div class="stepCircle animate__animated animate__fadeInUp delay0-5">
              <div class="circle"></div>
            </div>
          </div>
          <div class="step-right delay1 animate__animated animate__fadeInUp" v-html="item"></div>
        </div> -->
        <v-md-editor v-model="detailObj.stepNote" mode="preview" height="100%"> </v-md-editor>
      </div>
      <div v-else class="reader step-all">
        <iframe :src="detailObj.instruction" width="100%" height="100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'view-design'
export default {
  components: { Button },
  data() {
    return {
      detailObj: {},
      star: [1, 2, 3, 4, 5],
      stepNum: null
    }
  },
  created() {
    this.getDetail()
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.picSize()
      }, 2000)
    })
  },
  methods: {
    // 下载文档
    downFile() {
      window.open(this.detailObj.instruction)
    },
    getStep() {
      let index = this.detailObj.stepNote.indexOf('</p>')
      let num = 0
      while (index !== -1) {
        num++
        index = this.detailObj.stepNote.indexOf('</p>', index + 1)
      }
      this.stepNum = num
    },
    // 获取任务详情
    async getDetail() {
      const params = {
        uriCode: 'API008',
        bindVars: [
          {
            key: 'id',
            value: this.$route.params.id
          }
        ]
      }
      const res = await this.$fetch(params)
      this.detailObj = res
      // this.detailObj.stepNote = this.detailObj.stepNote.split('\n')
      // this.detailObj.stepNote = this.detailObj.stepNote
      if (res) {
        this.getStep()
      }
    },
    openTool(url) {
      window.open(url)
    },
    //  放大缩小图片
    picSize() {
      const imgs = document.querySelectorAll('.step-right p')
      if (imgs && imgs.length > 0) {
        imgs.forEach((item, i) => {
          imgs[i].addEventListener('click', e => {
            // 防止被document监听到
            e.stopPropagation()
            const isExpand = imgs[i].className.indexOf('active') !== -1
            if (!isExpand) {
              imgs[i].className += 'active'
            } else {
              imgs[i].className = imgs[i].className.replace('active', '')
            }
          })
          // // 点击其他位置
          // document.addEventListener('click', () => {
          //   imgs[i].className = imgs[i].className.replace('active', '')
          // })
        })
      }
    }
  }
}
</script>
<style lang="scss">
.task-detail {
  display: flex;
  flex-direction: row;
  height: 100%;

  .task-detail-left {
    box-sizing: border-box;
    position: relative;
    padding: 10px 20px;
    width: 377px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: calc(100vh - 70px);
    margin-right: 10px;
    margin-top: 10px;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    justify-content: space-between;
    border-radius: 8px;

    .task-detail-left-bottom {
      height: calc(100vh - 186px);
      overflow-y: auto;
      position: relative;
    }

    .downBtn {
      text-align: center;
      width: 100%;
      margin: 10px 0;

      button {
        width: 146px !important;
        height: 36px !important;
        background: #468fef !important;
        border-radius: 2px;
        margin: auto;
      }
    }

    .title {
      font-size: 16px;
      color: #505050;
      line-height: 25px;
      margin-bottom: 25px;

      .tit {
        color: #262626;
        font-weight: 600;
        cursor: pointer;
      }
    }

    .des {
      width: 326px;
      box-sizing: border-box;
      padding-right: 6px;
      max-height: 156px;
      line-height: 26px;
      margin: 10px 0 38px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: auto;
      text-align: justify;
    }

    .taps {
      line-height: 14px;
      display: flex;
      color: #666;
      font-size: 16px;

      .tap-left {
        height: 14px;
        width: 4px;
        background-color: #458eee;
        margin-right: 4px;
      }
    }

    .tool {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      img {
        cursor: pointer;
        width: 45px;
        height: 45px;
        margin-right: 10px;
        margin-top: 10px;
        border-radius: 10px !important;
      }
    }

    .name {
      color: #333333;
      line-height: 22px;
      font-size: 16px;
      margin: 14px 0 40px 0;
    }

    .difficulty {
      display: flex;
      flex-direction: row;
      margin-top: 11px;

      img {
        width: 24px;
        height: 22px;
      }
    }

    .mb79 {
      margin-bottom: 79px;
    }

    .mt60 {
      margin-top: 60px;
    }
  }

  .task-detail-right {
    border-radius: 8px;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    position: relative;
    background-color: #fff;
    width: 100%;
    margin: 10px 0 0 0;
    // max-height: 806px;
    overflow-y: auto;
    box-sizing: border-box;

    // .step-all {
    //   height: calc(100vh - 140px) !important;
    //   padding: 0 20px;
    //   overflow-y: auto;
    // }
    .step-all {
      padding: 0 20px;
      height: calc(100vh - 140px) !important;
    }

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 25px;
      margin: 10px 0 28px 10px;
    }

    // .step {
    //   display: flex;
    //   flex-direction: row;
    //   margin-left: 20px;
    //   position: relative;
    //   padding-bottom: 10px;

    //   .line {
    //     width: 1px;
    //     background-color: #d3d3d3;
    //     height: 100%;
    //     z-index: 1;
    //     margin-left: 5px;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //   }

    //   .step-left {
    //     width: 11px;
    //     display: flex;
    //     flex-direction: column;

    //     .stepCircle {
    //       z-index: 2;
    //       min-height: 45px;
    //       flex: 1;
    //       width: 11px;
    //       display: flex;
    //       flex-direction: column;
    //       justify-content: center;
    //       margin-bottom: 5px;

    //       &:first-child {
    //         .circle {
    //           height: 40px !important;
    //         }
    //       }

    //       &:last-child {
    //         margin-bottom: 0 !important;
    //         height: 40px;

    //         .circle {
    //           width: 11px;
    //           height: 11px;
    //           background-color: #468fef;
    //           border-radius: 50%;
    //           // margin-top: 15px;
    //         }
    //       }

    //       .circle {
    //         width: 11px;
    //         height: 11px;
    //         background-color: #468fef;
    //         border-radius: 50%;
    //         position: absolute;
    //         top: 16px;
    //         // margin-top: 17px;
    //       }
    //     }
    //   }

    //   &:last-child {
    //     padding-bottom: 0px !important;
    //     // .step-right {
    //     //   margin-bottom: 0 !important;
    //     // }
    //   }

    //   &:nth-child(1n) {
    //     .step-right {
    //       background: #f0f0f0 !important;
    //     }
    //   }

    //   &:nth-child(2n) {
    //     .step-right {
    //       background: #ecf3f5 !important;
    //     }
    //   }

    //   .step-right {
    //     display: flex;
    //     flex-direction: column;
    //     box-sizing: border-box;
    //     border-radius: 9px;
    //     margin: 0 20px 0px 20px !important;
    //     padding: 0 19px;
    //     line-height: 40px !important;
    //     max-width: 990px;
    //     white-space: normal;
    //     word-wrap: break-word;

    //     p {
    //       // display: block;
    //       box-sizing: border-box;
    //       color: #666;
    //       // margin: 0px 0 0px 10px;
    //       min-height: 40px !important;

    //       img {
    //         width: 30px;
    //         height: 30px;
    //         cursor: pointer;
    //         transition: all 0.2s ease-out;
    //         margin-right: 10px;

    //         &:last-child {
    //           margin-right: 0px;
    //         }
    //       }
    //     }

    //     p.active {
    //       width: 100%;

    //       img {
    //         transition: all 0.1s ease-in-out;
    //         margin: 20px 229px 0 230px;
    //         width: 500px !important;
    //         height: 500px;
    //         object-fit: contain;

    //         // height: 500px;
    //         &:last-child {
    //           margin-bottom: 20px !important;
    //         }
    //       }
    //     }
    //   }
    // }
  }

  .mt14 {
    margin-top: 14px;
  }

  .reader {
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px 20px 10px;
    height: calc(90vh - 80px);
  }
}
</style>
